import { apiCallWrapper } from 'traveldesk-ui'
import { SelectOptionModel } from 'traveldesk-ui'

export default class CountriesApiService {
    static getOptions = async (dispatch: any) => {
        return await apiCallWrapper<SelectOptionModel[]>('/api/countries/options', 'GET', dispatch)
    }
}
